<template>
  <div>
    <progress-bar :progress="currentPage / (Object.keys(pages).length - 1)" />
    
    <div id="pages">
      <page v-for="(page, key, index) in pages" :key="key" :currentPage="currentPage" :page="index + 1">
        <h1 v-if="page.title && key === 'intro'">{{page.title}}</h1>
        <h2 v-if="page.title && key !== 'results'">{{key !== 'intro' ? page.title : page.subtitle}}</h2>
        <h3 class="help-text" v-if="page.subtitle && key !== 'intro'"><em>{{page.subtitle}}</em></h3>
        <component :is="page.component"
          :content="page.content"
          :grid="page.grid"
          :store="key"
          :isRadio="page.isRadio"
          :limit="page.limit"
          :currentPage="currentPage"
          @stepped="updateCurrentPage($event);">
        </component>

        <loader v-if="currentPage >= (Object.keys(pages).length - 1)" :class="{ hidden: !isLoading }"/>
      </page>
    </div>

    <pager v-if="currentPage !== 1"
      :pageTotal="Object.keys(pages).length"
      @stepped="updateCurrentPage($event);"
      :currentPage="currentPage"
      prevText="Prev"
      :nextText="nextText"
    />


    <data-layer
      :solutionBuilderName="solutionBuilderName"
      :screenTitle="Object.values($store.state.pages)[currentPage - 1] ? Object.values($store.state.pages)[currentPage - 1].title : 'N/A'"
      :prevScreenTitle="Object.values($store.state.pages)[prevPage - 1] ? Object.values($store.state.pages)[prevPage - 1].title : 'N/A'"
      :screenNumber="currentPage"
      :prevPage="prevPage"
      :screenTotal="Object.keys(pages).length"
      :userPrevSelection="Object.values($store.state.selectedValues)[prevPage - 2]"
      :userSelection="Object.values($store.state.selectedValues)[currentPage - 3]"
    >
    </data-layer>
  </div>
</template>

<script>
import Intro from './components/Intro.vue'
import DragAndDrop from './components/DragandDrop/DragAndDrop.vue'
import RangeSelector from './components/RangeSelector/RangeSelector.vue'
import Gallery from './components/Gallery/Gallery.vue'
import Pager from './components/Pager.vue'
import ProgressBar from './components/ProgressBar.vue'
import RadioCarousel from './components/RadioCarousel/RadioCarousel.vue'
import Results from './components/Results/Results.vue'
import Form from './components/Form/Form.vue'
import Page from './components/Page/Page.vue'
import Loader from './components/Loader/Loader.vue';
import DataLayer from './components/DataLayer/DataLayer.vue'


export default {
  name: 'App',
  components: {
    Intro,
    DragAndDrop,
    RangeSelector,
    Gallery,
    Pager,
    ProgressBar,
    RadioCarousel,
    Results,
    Form,
    Page,
    Loader,
    DataLayer,
  },
  data() {
    return {
      currentPage: 1,
      prevPage: 0,
      pages: this.$store.state.pages,
      solutionBuilderName: 'Solution Configurator',
      isLoading: false,
    }
  },
  methods: {
    updateCurrentPage(e) {
      this.prevPage = this.currentPage;
      if (e && this.currentPage === (Object.keys(this.pages).length - 1)) {
        this.isLoading = true;

        setTimeout(() => {
          this.currentPage++

          setTimeout(() => {
            this.isLoading = false;
          }, 400)
        }, 1700)

      } else if (e && this.currentPage < Object.keys(this.pages).length) {
        this.currentPage++
      } else if (!e && this.currentPage > 0) {
        this.currentPage--
      }
    },
  },
  computed: {
    nextText() {
      if (this.currentPage === 1) {
        return `Let's get started`;
      } else if (this.currentPage === 10) {
        return `See my results`
      } else {
        return `Next`;
      }
    },
  },
  mounted() {
    for (const key of Object.keys(this.$store.state.selectedValues)) {

      if (localStorage[key] && key ==="challenges") {
        this.$store.state.selectedValues[key] = JSON.parse(localStorage[key])
      } else if (localStorage[key]){
        this.$store.state.selectedValues[key] = localStorage[key];
      }

      this.$store.watch(() => {
        if (Array.isArray(this.$store.state.selectedValues[key])) {
          localStorage.setItem(key, JSON.stringify(this.$store.state.selectedValues[key]))
        } else {
          localStorage[key] = this.$store.state.selectedValues[key];
        }
      })
    }
  },
}
</script>

<style>
  #app {
    line-height: 1.5;
    margin-top: 5rem;
    margin-bottom: 5rem;
    max-width: 950px;
    margin-left: auto;
    margin-right: auto;
    background-color: #fff;
    padding: 1rem 2rem 2rem;
    overflow: hidden;
    position: relative;
  }

  * {
    box-sizing: border-box;
  }

  h1 {
    font-size: 3.5rem;
    line-height: 130%;
  }
  h2 {
    font-size: 2.8rem;
    line-height: 140%;
  }
  h3 {
    font-size: 2.2rem;
    line-height: 150%;
  }

  p {
    font-size: 1.8rem;
    line-height: 180%;
  }

  h1, h2, h3, h4,
  .h1, .h2, .h3, .h4 {
    font-weight: 600;
    margin-top: 0;
  }

  body {
    background-color: #efefef;
    background-image: url('assets/solution-configurator-background-overlay-portal-dot-pattern.png')
  }

  object  {
    pointer-events: none;
  }

  img {
    max-width: 100%;
  }

  .form-container > .container > .component-content > .row {
    display: none;
  }

  #pages {
    position: relative;
  }

  #page {
    min-height: 660px;
  }

  /* Carousel */
  .carousel__slide {
    margin: 20px 0;
  }

  :root {
    --vc-clr-primary: #737578;
    --vc-clr-secondary: #c7c7c7;
  }

  .help-text {
    color: #737578;
    font-weight: 400;
  }
  .hidden {
    display: none !important;
    opacity: 0;
  }

  /* Styling for new site */
  .A5-breadcrumbs {
    background-color: transparent;
  }
</style>
